import * as React from 'react';
import { connect } from 'react-redux';
import { State } from './State';

let phrases: { [key: string]: string } = {};

// Are you here looking for how we know which language keys exists?
// We find that out dynaically using `webpack/translation-finder-loader.js`
// It goes through all code and looks for calls like this: `translate('xxx')`
// or `<Translate phrase="xxx" />`
// and automatically makes that phrase available in the frontend code.
export function translate(key: string, ...values: Array<number | string>) {
  if (!(key in phrases)) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Missing translation for phrase:', key);
      return key;
    }
    return '';
  } else {
    return format(phrases[key], ...values);
  }
}

export function setPhrases(p: { [name: string]: string }) {
  phrases = p;
}

// Format phrase using curly braces, e.g. `format('foo{0} {1}', 'bar', 'baz')` => Outputs: foobar baz
export function format(phrase: string, ...values: Array<number | string>) {
  const regex = /{(\d+)}/g;
  if (process.env.NODE_ENV !== 'production') {
    const placeholders: any[] = phrase.match(regex) || [];
    if (placeholders.length !== values.length) {
      const error = `The phrase "${phrase}" contains ${placeholders.length} placeholders
                     but ${values.length} placeholders was passed to translate(). The placeholders
                     passed in was: ${JSON.stringify(values)}`;
      throw new Error(error);
    }
  }
  return values.length === 0
    ? phrase
    : phrase.replace(
        regex,
        (match: string, index: number) => (typeof values[index] !== 'undefined' ? (values[index] as string) : match),
      );
}

type RequiredProps = {
  phrase: string;
  values?: Array<number | string>;
  component?: React.ComponentType<any> | string;
  componentProps?: any;
};

type ConnectedState = {
  languagePhrases: { [item: string]: string };
};

type Props = RequiredProps & ConnectedState;

function Translate(props: Props) {
  const { phrase, values = [], component: Component = 'span', languagePhrases, componentProps } = props;
  if (!(phrase in languagePhrases)) {
    if (process.env.NODE_ENV !== 'production') {
      throw new Error(`Missing translation for phrase: ${phrase}`);
    }
  }
  return values.length > 0 ? (
    <Component {...componentProps}>{format(languagePhrases[phrase], ...values)}</Component>
  ) : (
    <Component {...componentProps}>{format(languagePhrases[phrase])}</Component>
  );
}

export default connect(
  (state: State): ConnectedState => ({
    languagePhrases: state.appShellData.languagePhrases,
  }),
)(Translate);
